<div class="rd-widget table-widget widget-{{widgetConfig?.widgetId}}" *ngIf="widgetData">
  <table class="widgetCapRateReconciliationClass widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="33" class="widget-grid-column widget-header-red" style="text-align: start;">
            <widget-value class="widget-header-red" [align]="'left'" [color]="'white'" [bold]="true">Cap Rate Reconciliation</widget-value>
          </th>
        </tr>
        <tr class="dark-grey-line">
          <th scope="col" colspan="11">
            {{'capRateReconciliation.labelSource' | rdTranslate}}
          </th>
          <th scope="col" colspan="8">
            {{'capRateReconciliation.labelRange' | rdTranslate}}
          </th>
          <th scope="col" colspan="7">
            {{'capRateReconciliation.labelAverage' | rdTranslate}}
          </th>
          <th scope="col" colspan="7">
            {{'capRateReconciliation.labelMedian' | rdTranslate}}
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody class="extraTbody">
      <dynamic-growth-row [row]="2" [widget]="this" *ngIf="widgetData.showFirstRow">
        <tr class="light-grey-line">
          <td colspan="11">
            {{'capRateReconciliation.labelMarketExtractedRates' | rdTranslate}}
          </td>
          <td colspan="8">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationMarketExtractedRatesRangeFrom * 100 | rdLocalizedNumber:2}}% {{widgetData.usCapRateReconciliationMarketExtractedRatesRange}} {{widgetData.usCapRateReconciliationMarketExtractedRatesRangeTo * 100 | rdLocalizedNumber:2}}% </widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationMarketExtractedRatesAverage * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationMarketExtractedRatesMedian * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2 + (widgetData.showFirstRow?1:0)" [widget]="this" *ngIf="widgetData.showSecondRow">
        <tr class="white-line">
          <td colspan="11">
            {{'capRateReconciliation.labelBandofInvestment' | rdTranslate}}
          </td>
          <td colspan="8">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationBandOfInvestmentRange * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationBandOfInvestmentAverage * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationBandOfInvestmentMedian * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2 + (widgetData.showFirstRow?1:0) + (widgetData.showSecondRow?1:0)" [widget]="this" *ngIf="widgetData.showThirdRow">
        <tr class="light-grey-line">
          <td colspan="11">
            {{'capRateReconciliation.labelDebtCoverageRatio' | rdTranslate}}
          </td>
          <td colspan="8">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationDebtCoverageRatioRange * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationDebtCoverageRatioAverage * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationDebtCoverageRatioMedian * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2 + (widgetData.showFirstRow?1:0) + (widgetData.showSecondRow?1:0) + (widgetData.showThirdRow?1:0)" [widget]="this" *ngIf="widgetData.showFourthRow">
        <tr class="white-line">
          <td colspan="11">
            {{'capRateReconciliation.labelPublishedInvestorSurveys' | rdTranslate}}
          </td>
          <td colspan="8">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationPublishedInvestorSurveysRangeFrom * 100 | rdLocalizedNumber:2}}% {{widgetData.usCapRateReconciliationPublishedInvestorSurveysRange}} {{widgetData.usCapRateReconciliationPublishedInvestorSurveysRangeTo * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationPublishedInvestorSurveysAverage * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationPublishedInvestorSurveysMedian * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2 + (widgetData.showFirstRow?1:0) + (widgetData.showSecondRow?1:0) + (widgetData.showThirdRow?1:0) + (widgetData.showFourthRow?1:0)" [widget]="this" *ngIf="widgetData.showFifthRow">
        <tr class="light-grey-line">
          <td colspan="11">
            {{'capRateReconciliation.labelMarketExpertInterviews' | rdTranslate}}
          </td>
          <td colspan="8">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationMarketExpertInterviewsRangeFrom * 100 | rdLocalizedNumber:2}}% {{widgetData.usCapRateReconciliationMarketExpertInterviewsRange}} {{widgetData.usCapRateReconciliationMarketExpertInterviewsRangeTo * 100 | rdLocalizedNumber:2}}% </widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationMarketExpertInterviewsAverage * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'">{{widgetData.usCapRateReconciliationMarketExpertInterviewsMedian * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2 + (widgetData.showFirstRow?1:0) + (widgetData.showSecondRow?1:0) + (widgetData.showThirdRow?1:0) + (widgetData.showFourthRow?1:0) + (widgetData.showFifthRow?1:0)" [widget]="this" *ngIf="widgetData.usCapRateReconciliationJLLProjectionMedian">
        <tr class="red-line">
          <td colspan="11">
            {{'capRateReconciliation.labelJLLProjection' | rdTranslate}}
          </td>
          <td colspan="8">
            &nbsp;
          </td>
          <td colspan="7">
            &nbsp;
          </td>
          <td colspan="7">
            <widget-value [align]="'left'" [color]="'white'">{{widgetData.usCapRateReconciliationJLLProjectionMedian * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2 + (widgetData.showFirstRow?1:0) + (widgetData.showSecondRow?1:0) + (widgetData.showThirdRow?1:0) + (widgetData.showFourthRow?1:0) + (widgetData.showFifthRow?1:0) + (widgetData.usCapRateReconciliationJLLProjectionMedian?1:0)" [widget]="this" *ngIf="widgetData.usCapRateReconciliationJLLProjection2Median">
        <tr class="red-line">
          <td colspan="11">
            {{'capRateReconciliation.labelJLLProjection' | rdTranslate}} 2
          </td>
          <td colspan="8">
            &nbsp;
          </td>
          <td colspan="7">
            &nbsp;
          </td>
          <td colspan="7">
            <widget-value [align]="'left'" [color]="'white'">{{widgetData.usCapRateReconciliationJLLProjection2Median * 100 | rdLocalizedNumber:2}}%</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
    </tbody>
  </table>
</div>
